import { render, staticRenderFns } from "./PersonalConfirm.vue?vue&type=template&id=3b9dfe74"
import script from "./PersonalConfirm.vue?vue&type=script&lang=js"
export * from "./PersonalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports